// import { createMuiTheme } from '@mui/material/styles'

// export const customTheme = createMuiTheme({
// 	typography: {
// 		fontFamily: [
// 			'-apple-system',
// 			'BlinkMacSystemFont',
// 			'"Segoe UI"',
// 			'Roboto',
// 			'"Helvetica Neue"',
// 			'Arial',
// 			'"Noto Sans"',
// 			'sans-serif',
// 			'"Apple Color Emoji"',
// 			'"Segoe UI Emoji"',
// 			'"Segoe UI Symbol"',
// 			'"Noto Color Emoji"',
// 		].join(','),
// 	},
// })
import { defaultTheme } from 'react-admin'

export const customTheme = {
  ...defaultTheme,
  components: {
    ...defaultTheme.components,
    MuiTextField: {
      defaultProps: {
        variant: 'outlined',
      },
    },
    MuiFormControl: {
      defaultProps: {
        variant: 'outlined',
      },
    },
  },
}
